import { memo } from "react";

/**
 * A dropdown cell. Carries its own caret and positioning wrapper so it can sit
 * in any column without the table needing to know a select is there.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {{ value: string, label: string }[]} props.options
 * @param {boolean} [props.dirty]
 * @param {string} [props.error]
 * @param {boolean} [props.disabled]
 * @param {string} props.ariaLabel
 * @param {string} [props.placeholder] shown as the empty choice; omit to require a value
 * @param {(value: string) => void} props.onChange
 */
function SelectCell({ value, options, dirty, error, disabled, ariaLabel, placeholder, onChange }) {
  const classes = ["kgb-cell", dirty ? "kgb-cell--dirty" : "", error ? "kgb-cell--invalid" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="kgb-selectwrap">
      <select
        className={classes}
        value={value ?? ""}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-invalid={error ? "true" : undefined}
        title={error || undefined}
        onChange={(e) => onChange(e.target.value)}
      >
        {placeholder == null ? null : <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span className="kgb-caret" aria-hidden="true">
        ▾
      </span>
    </div>
  );
}

export default memo(SelectCell);
